import { Select, Text, View } from '@acin/ui-core';
import styled from 'styled-components';

// This named style should be the wrapper for the component i.e. the module
export const Documents = styled(View)`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Document = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: ${(p) => p.theme.spacing.getSize(2)} 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.borders.getValue(1)};

  &:hover {
    cursor: pointer;
  }
`;

export const Name = styled(Text)`
    wh
`;
export const Id = styled(Text)`
  margin-right: ${(p) => p.theme.spacing.getSize(3)};
  color: ${(p) => p.theme.colors.borders.getValue(1)};
`;

export const List = styled(View)`
  overflow-y: auto;
  flex: 1;
`;

export const Title = styled(View)`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: row;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: ${(p) => p.theme.spacing.getSize(3)};
`;

export const Date = styled(Title)`
  display: flex;
  flex: 0 0 12px;
  flex-direction: row;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: ${(p) => p.theme.spacing.getSize(3)};
  min-width: 140px;
`;

export const Status = styled(View)`
  display: flex;
  min-width: 120px;
`;

export const Header = styled(View)`
  flex-shrink: 0;
  flex-direction: row;
  display: flex;
  margin-bottom: ${(p) => p.theme.spacing.getSize(3)};
`;

export const StatusDropdown = styled(Select)`
  margin-left: ${(p) => p.theme.spacing.getSize(3)};
`;

export const DateDropdown = styled(Select)`
  margin-left: ${(p) => p.theme.spacing.getSize(3)};
`;

export const LoadingWrapper = styled(View)`
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  display: flex;
  padding: ${(p) => p.theme.spacing.getSize(10)} 0;
`;
